module.exports = __webpack_public_path__ + "static/media/canela-rs.2593642e.jpg";